import { useForm } from "react-hook-form"
import { HttpErrors } from "utils/HttpErrors"
import { reportError } from "utils/ErrorReporting"
import { FleLayout } from "components/views/fle/FleLayout"
import { Form } from "components/views/atoms/forms/Form"
import { TopSection } from "components/views/fle/TopSection"
import { LeftArrow, StyledReadonlyWell, SwitchH2ToBodyLarge } from "components/views/fle/Molecules"
import { Spacer } from "components/views/atoms/Atoms"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { FleLinkWrapper } from "components/views/atoms/Links"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import React from "react"
import CarrotClient from "carrot-api"
import Settings from "utils/CarrotConfig"
import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)

export const SetPassword = ({ email, onBack, onComplete }) => {
  const {
    register,
    errors,
    handleSubmit,
    formState: { isValid, isDirty }
  } = useForm({ mode: "onChange" })

  const onSubmit = handleSubmit((formData) => {
    onComplete(formData.password)
  })

  const validatePassword = async (password) => {
    try {
      await client.validatePassword(password)
    } catch (error) {
      if (error.name === HttpErrors.BAD_REQUEST) {
        return await error.response.text()
      }
      reportError(error)
    }
    return true
  }

  return (
    <FleLayout>
      <Form onSubmit={onSubmit}>
        <TopSection progressStep={1} leftOrBackArrow={<LeftArrow onClick={onBack} />} />
        <SwitchH2ToBodyLarge>{l`Here's your account email`}</SwitchH2ToBodyLarge>
        <Spacer height={1} />
        <StyledReadonlyWell>{email}</StyledReadonlyWell>
        <Spacer height={2} />
        <SwitchH2ToBodyLarge>Create a password</SwitchH2ToBodyLarge>
        <Spacer height={1} />
        <Spacer height={0.5} />
        <CompleteFormInput
          ref={register({ validate: validatePassword })}
          errors={errors}
          name="password"
          label={l`Password`}
          type="password"
        />
        <FleLinkWrapper>
          <ArrowLink onClick={onSubmit} enabled={isValid && isDirty}>
            Continue
          </ArrowLink>
        </FleLinkWrapper>
      </Form>
    </FleLayout>
  )
}
